import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { initializeNotificationsService } from 'Shared/Notifications/notification_service';
import { withBreakpointsContext } from 'Shared/utils/breakpoints';
import HeaderInteractive from './header-interactive';
import './menu-analytics';

initializeNotificationsService();

initializeChakraComponent('HeaderInteractive', withBreakpointsContext(HeaderInteractive));
